<template>
  <div class="container">
    <van-nav-bar
       left-text="返回"
       left-arrow
       @click-left="onClickLeft"
    />
    <div class="title">
      <span>请输入验证码</span>
      <div class="sendsms">
        <span>已发送至手机 {{phone}}</span>
        <div class="time" :class="isSend?'c_blue':'c_gray'" @click="sendCode">{{tips}}</div>
      </div>
    </div>
    <!-- 验证码输入框 -->
    <van-password-input
      :value="value"
      :length="4"
      :mask="false"
      :gutter="15"
      :error-info="smsCheck?'':'验证码错误，请重新输入。'"
      :focused="showKeyboard"
      @focus="showKeyboard = true"
    />
    <!-- 数字键盘 -->
    <van-number-keyboard
      :show="showKeyboard"
      @input="onInput"
      @delete="onDelete"
      @blur="showKeyboard = false"
    />
  </div>
</template>

<script>
  export default {
    name: "password-sms",
    data:function () {
      return {
        value:'',
        showKeyboard:true,
        phone:'',
        isSend:true,
        tips:'发送验证码',  //重新发送
        smsCheck:true
      }
    },
    mounted(){
      if(!!localStorage['reset_phone']){
        this.phone = localStorage['reset_phone'];
      }
      this.$indicator.close();
      this.sendCode();
    },
    methods:{
      //返回
      onClickLeft(){
        this.$router.push('/login');
      },
      //验证码输入
      onInput(key) {
        var $that = this;
        this.value = (this.value + key).slice(0, 4);
        // 验证码校验,正确跳转重置密码页面
        if(this.value.length == '4'){
          $that.$ajax.post($that.$$api.mobile.smsCheck,{
            'phone':$that.phone,
            'sms':$that.value,
          },function (res) {
            if(res.status == 200){
              if(res.data.status == '1'){
                $that.smsCheck= true;
                $that.$toast(res.data.msg);
                $that.$router.push({path:'/password-reset'});
              }else if(res.data.status == '-1'){
                $that.smsCheck= false;
                $that.$toast(res.data.msg);
              }
            }else{

            }
            return
          },function (err) {
            console.log(err);
          });
        }
      },
      //验证码删除键
      onDelete() {
        this.value = this.value.slice(0, this.value.length - 1);
      },
      //发送验证码
      sendCode:function () {
        var $that = this;
        let isSend = this.isSend;
        if(isSend){
          this.isSend = false;
          this.tips = '重新发送60s';
          var second = 60;
          var timer = setInterval(function () {
            second--;
            $that.tips = '重新发送 '+second+'s';
            if(second==0){
              clearInterval(timer);
              $that.tips = '发送验证码';
              $that.isSend = true;
            }
          },1000);
          //ajax
          this.$ajax.get(this.$$api.mobile.sendCode,{
            'phone':this.phone,
          });
        }
      }
    }
  }
</script>

<style scoped>
  .container{
    background: #fff;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    margin-top:-9vh !important;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  .van-password-input__security li{
    border: 1px solid #ebedf0;
  }
  .title{
    width: 100vw;
    height: calc(40vw - 46px);
    text-align: center;
    margin-top: 10vh;
    margin-bottom:2vh;
    font-size: 20px;
  }
  .sendsms{
    margin-top:3vh;
    font-size:14px;
    color:#8c8c8c;
  }
  .time{
    min-width: 26vw;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    margin-left: 3vw;
    border-radius: 5px;
    height: 10vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/password-sms.vue